globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};

appCustomerSpace.ModalShareBySmsOrEmail = (function()
{
  ModalShareBySmsOrEmail.listen = function() {
    ModalShareBySmsOrEmail.getModalOpener().on('click', function(){
      if(!ModalShareBySmsOrEmail.isBuilt()) {
        var buttonOpenerDefaultText = $(this).html();
        $(this).html('<i class="icon-spinner spinner"></i>');
        new appCustomerSpace.ModalShareBySmsOrEmail({
          buttonOpenerDefaultText: buttonOpenerDefaultText
        });
      }
    });
  }

  ModalShareBySmsOrEmail.getModalOpener = function() {
    return $('button#open-modal-share-by-sms-or-email')
  }

  ModalShareBySmsOrEmail.getModal = function() {
    return $('.modal#modal-share-by-sms-or-email')
  }

  ModalShareBySmsOrEmail.isBuilt = function() {
    return ModalShareBySmsOrEmail.getModal().length
  }

  ModalShareBySmsOrEmail.getModalFromServer = function(options, callback) {
    $.ajax({
      url: ModalShareBySmsOrEmail.getModalOpener().data('path'),
      method: 'GET',
      success: function(data) {
        if(data.response) {
          var $modal = $(data.view);
          $('body').prepend($modal);

          if(typeof(callback) == 'function') callback($modal);
        }

        if(options.buttonOpenerDefaultText != undefined) ModalShareBySmsOrEmail.getModalOpener().html(options.buttonOpenerDefaultText);
      },
      error: function(data) {
        if(options.buttonOpenerDefaultText != undefined) ModalShareBySmsOrEmail.getModalOpener().html(options.buttonOpenerDefaultText);
      }
    })
  }

  function ModalShareBySmsOrEmail(options) {
    if(options.buttonOpenerDefaultText != undefined) {
      this.buttonOpenerDefaultText = options.buttonOpenerDefaultText;
    }

    this.init();
  }

  ModalShareBySmsOrEmail.prototype =
  {
    init: function()
    {
      var self = this;
      ModalShareBySmsOrEmail.getModalFromServer({buttonOpenerDefaultText: self.buttonOpenerDefaultText}, function($modal){
        self.$modal = $modal;
        self.$form = self.$modal.find('form');

        self.$modal.find('input[type=radio]').uniform({
            radioClass: 'choice',
            wrapperClass: 'border-primary text-primary'
        });
        self.$modal.modal('show');
        self.$modal.on('hidden.bs.modal', function(){
          self.$modal.remove();
        });

        self.events();
      });
    },
    events: function()
    {
      var self = this;

      this.$modal.on('change', 'input[type=radio]', function(){
        var $this = $(this);
        if($this.val() == "1") {
          $('#form-group-emails').fadeIn();
          $('#form-group-phones').hide();
        } else {
          $('#form-group-phones').fadeIn();
          $('#form-group-emails').hide();
        }
      });

      this.$form.on('click', 'button', function(){
        $(this).submit();
      });

      this.$form.on('submit', function(){
        self.$modal.find('.modal-dialog').block({
            message: '<i class="icon-spinner spinner"></i>',
            overlayCSS: {
              backgroundColor: '#fff',
              opacity: 0.8,
              cursor: 'wait'
            },
            css: {
              border: 0,
              padding: 0,
              backgroundColor: 'none'
            }
        });

        $.ajax({
          method: $(this).attr('method'),
          data: $(this).serialize(),
          url: $(this).attr('action'),
          success: function(data) {
            if(data.response) {
              setTimeout(function(){
                self.$modal.find('.modal-dialog').block({
                    message: 'Merci !',
                    overlayCSS: {
                      backgroundColor: '#fff',
                      opacity: 0.9,
                      cursor: 'wait'
                    },
                    css: {
                      border: 0,
                      padding: 0,
                      backgroundColor: 'none',
                      color: '#43A047',
                      fontSize: '30px'
                    }
                });
                setTimeout(function(){
                  self.$modal.modal('hide');
                }, 2000);
              }, 1000);
            } else {
              setTimeout(function(){
                self.$modal.find('.modal-dialog').block({
                    message: data.message,
                    overlayCSS: {
                      backgroundColor: '#fff',
                      opacity: 0.9,
                      cursor: 'wait'
                    },
                    css: {
                      border: 0,
                      padding: 0,
                      backgroundColor: 'none'
                    }
                });
                setTimeout(function(){
                  self.$modal.find('.modal-dialog').unblock();
                }, 2000);
              }, 1000);
            }
          },
          error: function(data) {
            self.$modal.find('.modal-dialog').block({
              message: "Une erreur est survenue.",
              overlayCSS: {
                backgroundColor: '#fff',
                opacity: 0.8,
                cursor: 'wait'
              },
              css: {
                border: 0,
                padding: 0,
                backgroundColor: 'none'
              }
            })
          }
        });

        return false;
      })

      this.$form.on('click', '.link-add-field-item', function(){ self.addFieldItem($(this)); })
                .on('click', '.link-remove-field-item', function(){ self.removeFieldItem($(this)); });
    },
    addFieldItem: function($this) {
      var $last_field_item = $this.parent().find('.field-item').last(),
          $last_field_item_input = $last_field_item.find('input').first(),
          $new_field_item_input = $last_field_item_input.clone().val('').removeClass('has-error'),
          $new_field_item = $('<div class="field-item">\
                              ' + $new_field_item_input.prop('outerHTML') + '\
                              <a class="link-remove-field-item mt-5"><i class="icon-cross2 text-muted"></i></a>\
                            </div>');

      if($last_field_item_input.val() == "") {
        $last_field_item.addClass('has-error');
      } else {
        $last_field_item.removeClass('has-error');
        $new_field_item.insertAfter($last_field_item);
      }
    },
    removeFieldItem: function($this) {
      $this.parent('.field-item').remove();
    }
  }
  return ModalShareBySmsOrEmail;
})();
